const TOOL_META = {
  web_search: { icon: '🔍', loading: '正在搜索网络...', done: '搜索完成' },
  web_fetch: { icon: '🌐', loading: '正在抓取网页...', done: '抓取完成' },
  amazon_listing_fetch: { icon: '🛒', loading: '正在获取商品信息...', done: '获取完成' },
  asin_lookup: { icon: '📊', loading: '正在查询 ASIN 数据...', done: '查询完成' },
  compliance_check: { icon: '⚠️', loading: '正在合规检查...', done: '检查完成' },
  listing_score: { icon: '⭐', loading: '正在打分...', done: '评分完成' },
};
const DEFAULT_TOOL_META = { icon: '🔧', loading: '正在执行...', done: '执行完成' };

export function getToolMeta(toolName, isLoading) {
  const meta = TOOL_META[toolName] || DEFAULT_TOOL_META;
  return { icon: meta.icon, label: isLoading ? meta.loading : meta.done };
}

export function formatAgentStateLabel(state) {
  if (state === 'queued') return '等待系统执行名额…';
  if (state === 'loading') return '正在准备执行…';
  if (state === 'fallbacking') return '正在切换至智能兜底模式…';
  return state;
}

export function formatArtifactTime(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '刚刚';
  return date.toLocaleString('zh-CN', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function runStatusLabel(status) {
  return ({ QUEUED: '排队中', RUNNING: '运行中', COMPLETED: '已完成', FALLBACK: '已降级完成', FAILED: '失败', CANCELLED: '已取消' })[status] || status || '未知';
}

export function memoryStatusLabel(status) {
  return ({ proposed: '待确认', confirmed: '已确认', active: '使用中', rejected: '已拒绝', expired: '已过期', deleted: '已删除' })[status] || status || '未知';
}

export function memoryTypeLabel(type) {
  return ({ preference: '偏好', goal: '目标', constraint: '约束', decision: '决策', task_progress: '任务进度', external_fact: '外部事实', inference: '推断' })[type] || type || '记忆';
}
